module.exports = __webpack_public_path__ + "static/gradientTwo-29518c361bb176fc41397cb78072834f.png";